/* eslint-disable react/jsx-props-no-spreading */
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import Navigation from "./Nav";
import YearsNavigation from "./yearsNav";

const displayFormat = "DD-MMM-YYYY";
const fullFormat = "dddd, MMMM Do YYYY";

const monthsGrouped = [
  ["January", "February", "March"],
  ["April", "May", "June"],
  ["July", "August", "September"],
  ["October", "November", "December"]
];
const monthsFull = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];
function groupByN(n, data) {
  const result = [];
  for (let i = 0; i < data.length; i += n) result.push(data.slice(i, i + n));
  return result;
}
const getFirstDayOfMonth = dateObject => {
  const firstDay = moment(dateObject)
    .startOf("month")
    .format("d");
  return firstDay;
};
function getDates(obj) {
  return moment(obj, fullFormat).get("date");
}

function getDays(dateObject) {
  const days = moment(dateObject).daysInMonth();
  return days;
}
function getDisplayDate(dateObject) {
  return moment(dateObject, fullFormat).format(displayFormat);
}
function compare(a, b) {
  const A = moment(a, fullFormat).toISOString();
  const B = moment(b, fullFormat).toISOString();
  return moment(A).isBefore(B);
}
function isToday(params) {
  const today = moment().format(fullFormat);
  return today === params;
}
function Button({ children, disbaled, ...props }) {
  if (disbaled) {
    return (
      <button type="button" {...props} disabled>
        {children}
      </button>
    );
  }
  return (
    <button type="button" {...props}>
      {children}
    </button>
  );
}

function WeekDays() {
  return (
    <tr>
      <th>Sun</th>
      <th>Mon</th>
      <th>Tue</th>
      <th>Wed</th>
      <th>Thu</th>
      <th>Fri</th>
      <th>Sat</th>
    </tr>
  );
}
export default function Calendar({ style, minDate, maxDate, handleOnChange, value }) {
  const [dateObject, setDateObject] = useState(moment());
  const [grouped, setGrouped] = useState([]);
  const [showDays, setShowDays] = useState(true);
  const [showYears, setShowYears] = useState(false);
  const [showMonths, setShowMonths] = useState(false);
  const [tabkeyPressed, setTabkeyPressed] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (value) {
      setDateObject(moment(value, displayFormat));
    }
  }, [value]);

  const MinDateISO = moment(minDate, displayFormat).toISOString();
  const MaxDateISO = moment(maxDate, displayFormat).toISOString();
  const MinDate = moment(minDate, displayFormat).format(fullFormat);
  const MaxDate = moment(maxDate, displayFormat).format(fullFormat);
  const isMinDateValid = minDate ? moment(MinDateISO).isValid() : false;
  const isMaxDateValid = maxDate ? moment(MaxDateISO).isValid() : false;

  function setMonth(month) {
    const monthNo = monthsFull.indexOf(month);
    let newDateObject = { ...dateObject };
    newDateObject = moment(newDateObject).set("month", monthNo);
    setDateObject(newDateObject);
    setShowMonths(!showMonths);
    setShowDays(!showDays);
  }

  function setYear(year) {
    let newDateObject = { ...dateObject };
    newDateObject = moment(newDateObject).set("year", year);
    setDateObject(newDateObject);
    setShowMonths(!showMonths);
    setShowYears(!showYears);
  }

  function checkMinMax(g) {
    const min = isMinDateValid ? compare(g, MinDate) : false;
    const max = isMaxDateValid ? compare(MaxDate, g) : false;
    return min || max;
  }

  useEffect(() => {
    const empty = getFirstDayOfMonth(dateObject);
    const numberofDays = getDays(dateObject);
    if (!Number.isNaN(numberofDays) && numberofDays > 0) {
      const days = new Array(numberofDays).fill().map((_, i) =>
        moment(dateObject)
          .startOf("month")
          .add(i, "days")
          .format(fullFormat)
      );
      const firstDayOfMonth = [];
      for (let i = empty; i--;) {
        firstDayOfMonth.push(
          moment(dateObject)
            .startOf("month")
            .subtract(i + 1, "days")
            .format(fullFormat)
        );
      }
      const total = [...firstDayOfMonth, ...days];
      const g = groupByN(7, total);
      setGrouped(g);
    }
  }, [dateObject]);

  function handleCellClick(g) {
    const date = getDisplayDate(g);
    handleOnChange(date);
  }
  function keyPressed(event) {
    setTabkeyPressed(true);
  }

  return (
    <div className="calendar" style={{ ...style }}>
      {showYears ? <YearsNavigation handleClick={setYear} /> : (
        <>
          <div>
            <div className="calendar-header">
              <Navigation
                dateObject={dateObject}
                setDateObject={setDateObject}
                setShowMonths={setShowMonths}
                setShowYears={setShowYears}
                setShowDays={setShowDays}
                showMonths={showMonths}
                showYears={showYears}
              />
            </div>
          </div>
          <div>
            <input
              className="sr-only"
              type="text"
              name="hidden"
              onKeyDown={event => keyPressed(event)}
              ref={inputRef}
            />
            <table>
              <thead>{showDays && <WeekDays />}</thead>
              <tbody>
                {showDays && (
                  <>
                    {grouped.map(group => (
                      <tr key={group}>
                        {group.map(g => (
                          <td
                            key={g}
                            data-before-min={isMinDateValid ? compare(g, MinDate) : true}
                            data-min-date={isMinDateValid ? MinDate : "NA"}
                            data-today={isToday(g)}
                          >
                            <Button
                              key={g}
                              aria-label={g}
                              type="button"
                              disbaled={checkMinMax(g)}
                              onClick={() => handleCellClick(g)}
                              className={`fn-btn ${value === getDisplayDate(g) ? "selected-date" : ""}`}
                            >
                              {getDates(g)}
                            </Button>
                          </td>
                        ))}
                      </tr>
                    ))}
                  </>
                )}
                {showMonths && (
                  <>
                    {monthsGrouped.map(months => (
                      <tr key={months.join("-")}>
                        {months.map(m => (
                          <td key={m}>
                            <Button type="button" onClick={() => setMonth(m)} className="fn-btn">
                              {m}
                            </Button>
                          </td>
                        ))}
                      </tr>
                    ))}
                  </>
                )}
              </tbody>
            </table>
          </div>
          {tabkeyPressed && (
            <div className="pt-5 pb-2 pr-2 d-flex justify-content-end">
              <Navigation
                dateObject={dateObject}
                setDateObject={setDateObject}
                setShowMonths={setShowMonths}
                setShowYears={setShowYears}
                setShowDays={setShowDays}
                showMonths={showMonths}
                showYears={showYears}
                hideNav
                inputRef={inputRef}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
}
